export const comparePageNumbers = (numbersA: number[], numbersB: number[]): boolean => {
  if (numbersA.length !== numbersB.length) {
    return false;
  }

  return numbersA.every((value) => numbersB.includes(value));
};
